import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { CadastroModalUtil } from '../../../util/modal/cadastro.modal.util';
import { SessaoUtil } from '../../../util/sessao-util';
import { UtilService } from '../../../util/util.service';
import { AlterarSenhaAuxModel } from '../../../util/model/alterar-senha-aux.model';
import { UsuarioService } from '../../../service/usuario.service';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss'],
  providers: [UsuarioService]
})
export class AlterarSenhaComponent implements OnInit {

  entityForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toasterUtil: ToasterUtilService,
    private cadastroModalUtil: CadastroModalUtil,
    private sessaoUtil: SessaoUtil,
    private usuarioService: UsuarioService
  ) {

   }

  ngOnInit() {
    this.criarFormGroup();

    this.entityForm.controls['id'].setValue(this.sessaoUtil.idUsuarioLogado);
    this.entityForm.controls['nome'].setValue(this.sessaoUtil.nomeUsuarioLogado);
    this.entityForm.controls['nome'].disable();
  }

  onCancelar(event){
    this.cadastroModalUtil.closeModal();
  }

  onAlterar(event){
    let error: boolean = false;

    if(UtilService.empty(this.entityForm.controls['senhaAtual'].value)){
      this.toasterUtil.alerta('Senha atual não foi informada.');
      error = true;
    }

    if(UtilService.empty(this.entityForm.controls['senhaNova'].value)){
      this.toasterUtil.alerta('A nova senha não foi informada.');
      error = true;
    }else{
      if(this.entityForm.controls['senhaNova'].value == this.entityForm.controls['senhaAtual'].value){
        this.toasterUtil.alerta('A nova senha não pode ser a mesma que a senha atual.');
        error = true;
      }
    }

    if(UtilService.empty(this.entityForm.controls['confirmacaoSenha'].value)){
      this.toasterUtil.alerta('A confirmação da senha não foi informada.');
      error = true;
    }

    if((!UtilService.empty(this.entityForm.controls['senhaNova'].value)) && (!UtilService.empty(this.entityForm.controls['confirmacaoSenha'].value)) && this.entityForm.controls['senhaNova'].value != this.entityForm.controls['confirmacaoSenha'].value){
      this.toasterUtil.alerta('A confirmação da senha não confere com a senha informada.');
      error = true;
    }

    if(error){
      return;
    }

    let entity: AlterarSenhaAuxModel = this.preencherObjeto();

    this.usuarioService.alterarSenha(entity).then((retorno: Boolean) => {
      if(UtilService.booleanNotNull(retorno)){
        this.toasterUtil.sucesso('Senha alterada com sucesso.');
        this.cadastroModalUtil.closeModal();
      }
    }).catch(erro => this.toasterUtil.erro(erro));
  }

  preencherObjeto() : AlterarSenhaAuxModel{
    let entity: AlterarSenhaAuxModel = new AlterarSenhaAuxModel();

    entity.id = this.entityForm.controls['id'].value;
    entity.senhaAtual = this.entityForm.controls['senhaAtual'].value;
    entity.senhaNova = this.entityForm.controls['senhaNova'].value;
    entity.confirmacaoSenha = this.entityForm.controls['confirmacaoSenha'].value;

    return entity;
  }

  criarFormGroup(){
    this.entityForm = this.fb.group({
      id: [''],
      nome: [''],
      senhaAtual: [''],
      senhaNova: [''],
      confirmacaoSenha: ['']
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/alterar-senha/alterar-senha.component.ts